<template>
<!-- <Loader v-if="paymentStore.isLoadingHistory || subscriptionStore.isLoading"/> -->
  <div class="my-subscription">
    <!-- Кнопка домой -->
    <HomeButton />
    
    <div class="my-subscription__top-row">
        <div class="my-subscription__title">Подписка id: {{ subscriptionStore.subscription?.id }}</div>
        <div class="my-subscription__period my-subscription-period">
            <span class="my-subscription-period__expired" 
                v-if="
                subscriptionStore.subscription && 
                Object.keys(subscriptionStore.subscription) && 
                subscriptionStore.subscription.exp_date">

                    до {{ formatDateToRussian(new Date(subscriptionStore.subscription.exp_date)) }}

            </span>

            <span class="my-subscription-period__expired-ubtitle">{{ subscriptionStore.subscription?.is_test ? 'Пробный период' : ''}}</span>
        </div>
        <div class="my-subscription__traffic my-subscription-traffic">
            <span class="my-subscription-traffic__traffic">{{ subscriptionStore.subscription?.is_active ? 'online' : 'offline' }}{{ displayTraffic }}</span>
        </div>
        <div class="my-subscription__buttons-row">
            <BaseButton 
                :full-width="true" 
                styles="secondary-200" 
                text="Отменить автосписание"
                :is-disabled="!paymentStore.autopayment"
                icon="WalletOff"
                @on-submit="handleDisableAutopayments"
                />
            <BaseButton 
                :full-width="true" 
                styles="secondary-100" 
                icon="Gear"
                text="Настроить подписку"
                @on-submit="goToSetup"
                />
        </div>
    </div>
    <div class="my-subscription__bottom-row">
        <BaseButton 
            text="Продлить подписку" 
            styles="primary-gradient" 
            icon="WalletBlack"
            :subtitile="`от ${String(minPriceValue)} руб.`"
            subtitle-style="medium"
            :full-width="true"
            @on-submit="goToPayment"
        />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { usePaymentStore } from '@/entities/Payment/model/paymentStore';
import { useSubscriptionStore } from '@/entities/Subscription/model/subscriptionStore';
import { formatDateToRussian } from '@/shared/utils/date/formatDateToRussian';
import { parseTraffic } from '@/shared/utils/traffic/parseTraffic';
import { useUserStore } from '@/stores/useUser';
import BaseButton from '@/ui/components/Base/BaseButton.vue';
import HomeButton from '@/ui/components/HomeButton.vue';
import { computed, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useModal } from '@/shared/lib/modal/useModal';
import Loader from '@/ui/components/Loader.vue';

console.log('🎯 MySubscription: Компонент инициализирован')

// Флаг для предотвращения множественной инициализации
let isInitializing = false

const userStore = useUserStore()
const subscriptionStore = useSubscriptionStore()
const paymentStore = usePaymentStore()
const router = useRouter()
const { openDisableAutopaymentsModal } = useModal()

const minPriceValue = computed(() => {
    if(paymentStore.tariffs.length) {
        return Math.min(...paymentStore.tariffs.map(tariff => tariff.price))
    }
    return null
})

// Общее состояние загрузки
const isDataLoading = computed(() => {
    return subscriptionStore.isLoading || userStore.isLoading
})

// Computed для правильного отображения трафика
const displayTraffic = computed(() => {
    const subscription = subscriptionStore.subscription
    
    // Если нет подписки или идет загрузка, не показываем трафик
    if (!subscription || !Object.keys(subscription).length || isDataLoading.value) {
        return ''
    }
    
    // Если lifetime_used_traffic отсутствует, null, undefined или NaN
    const traffic = subscription.lifetime_used_traffic
    if (traffic === null || traffic === undefined || String(traffic) === 'NaN') {
        return ''
    }
    
    // Возвращаем отформатированный трафик
    return ` • ${parseTraffic(traffic)}`
})

// Загружаем данные при монтировании компонента
onMounted(async () => {
    if (isInitializing) {
        console.log('⚠️ MySubscription onMounted: Инициализация уже выполняется, пропускаем')
        return
    }
    
    isInitializing = true
    console.log('🔄 MySubscription onMounted: Начинаем инициализацию страницы')
    
    try {
        // Получаем ID подписки из роута
        const subscriptionId = router.currentRoute.value.params.id as string
        
        if (subscriptionId) {
            // Загружаем конкретную подписку по ID
            console.log('📡 MySubscription: Загружаем подписку по ID:', subscriptionId)
            await subscriptionStore.fetchSubscriptionById(subscriptionId)
        } else {
            // Загружаем данные подписки, если их нет
            if (!subscriptionStore.subscription) {
                console.log('📡 MySubscription: Загружаем данные подписки')
                await subscriptionStore.fetchSubscription()
            } else {
                console.log('✅ MySubscription: Данные подписки уже загружены')
            }
        }
        
        // Загружаем историю транзакций (проверяем, не загружали ли недавно)
        console.log('📜 MySubscription: Загружаем историю транзакций')
        await paymentStore.fetchBillsHistory(false) // false = не принуждать обновление
        
        // Загружаем тарифы для отображения минимальной цены, если их нет
        if (paymentStore.tariffs.length === 0) {
            console.log('💰 MySubscription: Загружаем тарифы')
            await paymentStore.fetchTariffs(subscriptionStore.subscription?.id)
        } else {
            console.log('✅ MySubscription: Тарифы уже загружены')
        }
        
        console.log('✅ MySubscription onMounted: Инициализация завершена успешно')
    } catch (error) {
        console.error('❌ MySubscription onMounted: Ошибка при загрузке данных:', error)
    } finally {
        isInitializing = false
    }
})

onUnmounted(() => {
    console.log('🗑️ MySubscription: Компонент размонтирован')
    isInitializing = false // Сбрасываем флаг при размонтировании
})

function goToPayment() {
  console.log('🔄 MySubscription: goToPayment called for extension')
  
  // Устанавливаем флаги для продления подписки
  sessionStorage.setItem('purchaseType', 'extension')
  sessionStorage.setItem('cameFromHome', 'true')
  
  console.log('🔄 MySubscription: sessionStorage set:', {
    purchaseType: sessionStorage.getItem('purchaseType'),
    cameFromHome: sessionStorage.getItem('cameFromHome')
  })
  
  router.push('/payment')
}

function goToSetup() {
  console.log('⚙️ MySubscription: goToSetup called')
  
  // Переходим на страницу установки с ID текущей подписки
  const subscriptionId = subscriptionStore.subscription?.id
  if (subscriptionId) {
    router.push(`/setup/${subscriptionId}`)
  } else {
    router.push('/setup')
  }
}

function handleDisableAutopayments() {
  openDisableAutopaymentsModal()
}
</script>

<style lang="scss">
.my-subscription {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 40px 20px;
    box-sizing: border-box;
    overflow-y: hidden;
    overflow-x: hidden;

    &__top-row {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .my-subscription__buttons-row {
            margin-top: 36px;
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
    }

    &__bottom-row {
        display: flex;
        flex-direction: column;
        gap: 8px;

        button {
            height: 25px;
        }
    }

    &__title {
        @include h1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.my-subscription-period {
    margin-top: 36px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__expired {
        @include p1-regular;
        color: $secondary-300;
        display: inline-block;
        background: $primary-gradient;
        padding: 8px 12px;
        border-radius: 16px;
        text-transform: uppercase;
    }

}

.my-subscription-traffic {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__traffic {
        @include p2-medium;
        color: $primary-100;
        display: inline-block;
    }
}
</style>